import copy from 'copy-to-clipboard'
import { Toast } from 'antd-mobile'
const copyToClipboard = (txt) => {
    try {
        var textarea = document.createElement("textarea");
        textarea.value = txt;
        document.body.appendChild(textarea);
        textarea.select();

        if( document.execCommand ) {
            document.execCommand("copy");
            document.body.removeChild(textarea);
            Toast.show(`已复制!`)
        }else {
            copy(txt)
            Toast.show(`已复制!`)
        }
    } catch (error) {
        copy(txt)
        Toast.show(`已复制!`)
    }
}

export default copyToClipboard